import { apiAuth, apiResponseType } from ".";

export const getSellersData = (
  page: number = 1,
  unity_id?: string
): apiResponseType =>
  apiAuth.get(`sellers?page=${page}${unity_id ? `&unity_id=${unity_id}` : ""}`);

export const registerSellersData = (data) =>
  apiAuth.postForm("/sellers/store", data) as apiResponseType;
export const deleteSellersData = (uuid: string) =>
  apiAuth.delete(`sellers/${uuid}/destroy`) as apiResponseType;
export const updateSellersData = (uuid: string, data) =>
  apiAuth.postForm(`sellers/${uuid}/update`, data) as apiResponseType;

export const getShowSellers = (uuid: string) =>
  apiAuth.get(`sellers/${uuid}/show`) as apiResponseType;

export const searchSellersData = (params: {
  name: string;
  unity_id?: string;
}): apiResponseType =>
  apiAuth.get(
    `sellers?name=${params.name}${
      params.unity_id ? `` : ""
    }`
  );

export const setStatusSellers = (uuid: string) =>
  apiAuth.put(`sellers/${uuid}/toggle-status`) as apiResponseType;

export const getSelectSellers = (params: { unity_id?: string; name?: string; is_active?: boolean }) => {
  const queryParams = new URLSearchParams();
  if (params.unity_id) queryParams.append("unity_id", params.unity_id);
  if (params.name) queryParams.append("name", params.name);
  if (params.is_active !== undefined) queryParams.append("is_active", params.is_active ? "1" : "0");
  const queryString = queryParams.toString();
  return apiAuth.get(`sellers/select${queryString ? `?${queryString}` : ""}`) as apiResponseType;
};

export const getSellersDataWithFilters = (params: {
  page?: number;
  per_page?: number;
  name?: string;
  unity_id?: string;
  is_active?: boolean;
}): apiResponseType => {
  const queryParams = new URLSearchParams();
  if (params.page) queryParams.append("page", params.page.toString());
  if (params.per_page) queryParams.append("per_page", params.per_page.toString());
  if (params.name) queryParams.append("name", params.name);
  if (params.unity_id) queryParams.append("unity_id", params.unity_id);
  if (params.is_active !== undefined) queryParams.append("is_active", params.is_active ? "1" : "0");
  return apiAuth.get(`sellers?${queryParams.toString()}`);
};
